export var SavedFilterType;
(function (SavedFilterType) {
    SavedFilterType["Contact"] = "contact";
    SavedFilterType["Invoice"] = "invoice";
    SavedFilterType["Escalation"] = "escalation";
    SavedFilterType["Action"] = "action";
    SavedFilterType["ReportAged"] = "report_aged";
    SavedFilterType["ReportLateFee"] = "report_latefee";
    SavedFilterType["ReportEmail"] = "report_email";
    SavedFilterType["ReportPaymentPlan"] = "report_paymentplan";
})(SavedFilterType || (SavedFilterType = {}));
// Report saved filters are per-user (reports span orgs and live outside org
// context); everything else is org-scoped and shared across the org
export const REPORT_SAVED_FILTER_TYPES = [
    SavedFilterType.ReportAged,
    SavedFilterType.ReportLateFee,
    SavedFilterType.ReportEmail,
    SavedFilterType.ReportPaymentPlan,
];
export function isUserScopedSavedFilterType(type) {
    return REPORT_SAVED_FILTER_TYPES.includes(type);
}
// Types whose export can be emailed on a schedule (they have an export background task)
export const SCHEDULABLE_SAVED_FILTER_TYPES = [
    SavedFilterType.Contact,
    SavedFilterType.Invoice,
    SavedFilterType.Action,
];
export function isSchedulableSavedFilterType(type) {
    return SCHEDULABLE_SAVED_FILTER_TYPES.includes(type);
}
// Same strings as PolicyIntervalType so the backend can reuse its next-date helper
export var SavedFilterScheduleInterval;
(function (SavedFilterScheduleInterval) {
    SavedFilterScheduleInterval["Weekly"] = "weekly";
    SavedFilterScheduleInterval["Monthly"] = "monthly";
})(SavedFilterScheduleInterval || (SavedFilterScheduleInterval = {}));
export const SAVED_FILTER_SCHEDULE_MAX_RECIPIENTS = 10;
//# sourceMappingURL=savedFilter.js.map